import actions from './actions';

const {
  DESIGNATIONS_READ_BEGIN,
DESIGNATIONS_READ_SUCCESS,
DESIGNATIONS_READ_ERR,

  DESIGNATIONS_ADD_BEGIN,
DESIGNATIONS_ADD_SUCCESS,
DESIGNATIONS_ADD_ERR,

  DESIGNATIONS_UPDATE_BEGIN,
DESIGNATIONS_UPDATE_SUCCESS,
DESIGNATIONS_UPDATE_ERR,
} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const addinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const updateinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const DESIGNATIONSReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case DESIGNATIONS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case DESIGNATIONS_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case DESIGNATIONS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const DESIGNATIONSAddReducer = (state = addinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case DESIGNATIONS_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case DESIGNATIONS_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case DESIGNATIONS_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const DESIGNATIONSUpdateReducer = (state = updateinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case DESIGNATIONS_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case DESIGNATIONS_UPDATE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case DESIGNATIONS_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { DESIGNATIONSAddReducer, DESIGNATIONSReducer, DESIGNATIONSUpdateReducer };
